import { agentAutoUpdateSettingSchema, requestAgentUpdateCheckBodySchema, requestAgentUpdateCheckResponseSchema, updateAgentAutoUpdateSettingBodySchema, } from '../contracts/agent-auto-update';
import { organizationIdSchema, } from '../contracts/organizations';
import { parseSchema } from '../errors';
/*
  KIR-5191 — automatic agent updates. Dashboard helpers for the org switch
  (Settings > Organization) and "Try update now". All three routes answer 404
  while the `agent_auto_update` flag is off for the organization.
*/
/**
 * Read the organization's "Automatic agent updates" switch. On by default.
 *
 * Authorization: any organization role.
 */
export async function getAgentAutoUpdateSetting(client, organizationId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.get(`/organizations/${validatedId}/agent-auto-update`);
    return parseSchema(agentAutoUpdateSettingSchema, response);
}
/**
 * Turn automatic agent updates on or off. Audited.
 *
 * Authorization: Owner or Manager.
 */
export async function updateAgentAutoUpdateSetting(client, organizationId, body) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedBody = parseSchema(updateAgentAutoUpdateSettingBodySchema, body);
    const response = await client.put(`/organizations/${validatedId}/agent-auto-update`, validatedBody);
    return parseSchema(agentAutoUpdateSettingSchema, response);
}
/**
 * "Try update now": ask one user's connected agents to check for an update
 * immediately. Best effort — an agent that is not connected checks at its
 * next scheduled check, and every backend gate still applies.
 *
 * Authorization: Owner or Manager.
 */
export async function requestAgentUpdateCheck(client, organizationId, body) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedBody = parseSchema(requestAgentUpdateCheckBodySchema, body);
    const response = await client.post(`/organizations/${validatedId}/agent-auto-update/check`, validatedBody);
    return parseSchema(requestAgentUpdateCheckResponseSchema, response);
}
//# sourceMappingURL=agent-auto-update.js.map